module.exports = __webpack_public_path__ + "img/us-ga.1c70cb42.svg";